import TeacherConstant from "../../utils/constants/TeacherConstant";
import "../../css/modal/UserLessonListModal.css"
import "../../css/userPage/LessonHistory.css"
import {useEffect, useState} from "react";
import proxy from "../../utils/Proxy";
import Pagination from "../footer/Pagination";
import {getDateString} from "../../utils/Utils";
import LessonModifyModal from "../modal/LessonModifyModal";

let LessonHistoryPage = (props) => {
    let [lessons, setLessons] = useState(null)
    let [listLength, setListLength] = useState(0);
    let [page, setPage] = useState(1);

    let [selectedLesson, setSelectedLesson] = useState(null);
    let [needUpdate, setNeedUpdate] = useState(false)

    let [cancelModalOpened, setCancelModalOpened] = useState(false);

    let onRowSelect = (lesson) => {
        setSelectedLesson(lesson)
        setCancelModalOpened(true)
    }

    let onCloseModal = () => {
        setSelectedLesson(null)
        setCancelModalOpened(false)
    }

    let getTeacherName = (teacherid) => {
        if (props.data === null)
            return null;
        let teacher = props.data.teachers[teacherid];
        return TeacherConstant.major_symbol[teacher.major] + teacher.name;
    }
    let getTables = () => {
        if (props.data === null || lessons === null)
            return [];
        let ret = [];
        for (let lesson of lessons) {
            let key = "lessonid:" + lesson.lessonid
            ret.push(<div
                className={"lesson-history-data-row lesson-history-data-row-not-done"}
                key={key} onClick={() => {
                        onRowSelect(lesson)
            }}>
                <div className="lesson-element-cell lesson-user-column-teacher">
                    <p>{getTeacherName(lesson.teacherid)}</p>
                </div>
                <div className="lesson-element-cell lesson-user-column-date">
                    <p>{getDateString(new Date(lesson.due))} {lesson.hour}시</p>
                </div>
                <div className="lesson-element-cell lesson-user-column-done">
                    <p>{lesson.is_done ? "완료" : "미완료"}</p>
                </div>
            </div>)
        }
        return ret;
    }

    useEffect(() => {
        let countPerPage = 10;
        proxy.get("/api/lessons/history?page=" + page + "&count=" + countPerPage).then(res => {
            let data = res.data.data;
            setListLength(res.data.totalLength)
            setLessons(data)
            setNeedUpdate(false)
        }).catch(err => {
            window.alert(err.response.data.message);
        })
    }, [page, needUpdate])

    return lessons !== null ? (<>
        <div className="content-container">
            <div className="content-title">
                <p>레슨 내역</p>
            </div>
            <div className="lesson-history-container">
                <div className="lesson-history-table-container">
                    <div className="lesson-history-table">
                        <div className="lesson-list-table-header">
                            <div className="lesson-history-header-row">
                                <div className="lesson-element-cell lesson-user-column-teacher">
                                    <p>강사</p>
                                </div>
                                <div className="lesson-element-cell lesson-user-column-date">
                                    <p>수강 일자</p>
                                </div>
                                <div className="lesson-element-cell lesson-user-column-done">
                                    <p>완료 여부</p>
                                </div>
                            </div>
                        </div>
                        {getTables()}
                    </div>
                </div>
                <Pagination page={page} setPage={setPage.bind(this)} listLength={listLength}
                            countPerPage={10}
                ></Pagination>
            </div>
        </div>
        {
            cancelModalOpened && selectedLesson !== null ?
                <LessonModifyModal opened={cancelModalOpened} lesson={selectedLesson} data={props.data}
                                   onCloseClick={onCloseModal.bind(this)} needUpdate={needUpdate}
                                   setNeedUpdate={setNeedUpdate.bind(this)} isAdmin={false}
                                   setNeedInfoRefresh={props.setNeedInfoRefresh}/> : null
        }
    </>) : null
}
export default LessonHistoryPage;
